const OFFICE_ANALYTICS_REFRESH_EVENT = "office-analytics-refresh";

export function emitOfficeAnalyticsRefresh(payload = {}) {
    if (typeof window === "undefined") return;

    window.dispatchEvent(
        new CustomEvent(OFFICE_ANALYTICS_REFRESH_EVENT, {
            detail: {
                officeId: payload.officeId || "",
                orderId: payload.orderId || "",
                reason: payload.reason || "",
                source: payload.source || "",
                at: Date.now(),
            },
        })
    );
}

export function subscribeOfficeAnalyticsRefresh(handler) {
    if (typeof window === "undefined" || typeof handler !== "function") {
        return () => { };
    }

    const listener = (event) => {
        handler(event.detail || {});
    };

    window.addEventListener(OFFICE_ANALYTICS_REFRESH_EVENT, listener);

    return () => {
        window.removeEventListener(OFFICE_ANALYTICS_REFRESH_EVENT, listener);
    };
}

export { OFFICE_ANALYTICS_REFRESH_EVENT };